import React from 'react';

interface WeekDaysProps {
    weekDays: string[];
}

const WeekDays: React.FC<WeekDaysProps> = ({ weekDays }) => {
    return (
        <div className="grid grid-cols-7 mb-2 border-b border-gray-200 dark:border-gray-700 pb-2">
            {weekDays.map((day, index) => (
                <div key={index} className="flex justify-center">
                    <span className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider py-1">
                        {day.substring(0, 1)}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default React.memo(WeekDays);